var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharescreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shareScreen"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30262",
    "data-name": "Rectangle 30262",
    width: 24,
    height: 24,
    transform: "translate(394 688)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shareScreen-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30274",
    "data-name": "Rectangle 30274",
    width: 8,
    height: 8,
    transform: "translate(-0.478)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_859",
    "data-name": "Mask Group 859",
    transform: "translate(-394 -688)",
    clipPath: "url(#shareScreen)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-08-22T152617.550",
    "data-name": "svgexport-6 - 2022-08-22T152617.550",
    transform: "translate(392.286 686.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47966",
    "data-name": "Path 47966",
    d: "M7.714,20.571H4.286A2.571,2.571,0,0,1,1.714,18V6.857A2.572,2.572,0,0,1,4.286,4.286H23.143a2.571,2.571,0,0,1,2.571,2.571V18a2.571,2.571,0,0,1-2.571,2.571H19.714v.668a1.9,1.9,0,0,1-1.9,1.9H9.618a1.9,1.9,0,0,1-1.9-1.9Zm1.714,0v.668a.189.189,0,0,0,.189.189h8.193A.189.189,0,0,0,18,21.239v-.668ZM12.857,11.5l-.961.961a.857.857,0,0,1-1.212-1.212l2.424-2.424a.857.857,0,0,1,1.212,0l2.424,2.424a.857.857,0,1,1-1.212,1.212l-.961-.961v3.931a.857.857,0,1,1-1.714,0Z",
    fill: "#382464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_860",
    "data-name": "Mask Group 860",
    transform: "translate(402.478 694)",
    clipPath: "url(#shareScreen-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-08-22T152721.824",
    "data-name": "svgexport-6 - 2022-08-22T152721.824",
    transform: "translate(0.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85921",
    "data-name": "Group 85921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85920",
    "data-name": "Group 85920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47967",
    "data-name": "Path 47967",
    d: "M1,3.242a.233.233,0,0,0,.168.071H2.4a.174.174,0,0,1,.174.174V7.342a.233.233,0,0,0,.233.233h2.4a.233.233,0,0,0,.233-.233V3.486a.174.174,0,0,1,.174-.174H6.855a.233.233,0,0,0,.167-.4L4.18.07a.231.231,0,0,0-.331,0L1.007,2.912A.233.233,0,0,0,1,3.242Z",
    transform: "translate(-0.937 0)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharescreen);
export default __webpack_public_path__ + "static/media/sharescreen.46a02ca28d43b510fd04a39547663e9d.svg";
export { ForwardRef as ReactComponent };